import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import ChartContainer from '../charts/ChartContainer';

Chart.register(...registerables);

const RejectedMissedChart = ({ data, filters }) => {

  const getDateStr = (date) =>
  date instanceof Date ? date.toLocaleDateString('en-CA') : new Date(date).toLocaleDateString('en-CA');

  // Apply filters
  const filtered = data.filter((d) => {
    const matchCustomer = !filters.customer || d.Customer === filters.customer;
    const matchAgent = !filters.agent || d.Agent === filters.agent;
    const matchDate = !filters.selectedDate || getDateStr(d.Date) === filters.selectedDate;
    return matchCustomer && matchAgent && matchDate;
  });

  // Track data per date
  const grouped = {};

  // Track segments with missed/rejected and abandoned
  const segments = {};

  filtered.forEach((d) => {
    const dateStr = getDateStr(d.Date);
    const segmentId = d.Segment;

    if (!grouped[dateStr]) {
      grouped[dateStr] = { Rejected: 0, Missed: 0, ResultedInAbandoned: 0 };
    }

    // Reclassify missed call with < 20s ring time as abandoned, so don't count it
    const validMissed = d.Missed === 1 && d.RingTime >= 20;

    // Count chart bars
    if (d.Rejected === 1) grouped[dateStr].Rejected += 1;
    if (validMissed) grouped[dateStr].Missed += 1;

    // Track each segment
    if (!segments[segmentId]) {
      segments[segmentId] = {
        hadMissedOrRejected: false,
        hadAbandoned: false,
        firstDate: d.Date instanceof Date ? d.Date : new Date(d.Date),
      };
    }

    if (d.Rejected === 1 || validMissed) {
      segments[segmentId].hadMissedOrRejected = true;
    }

    if (d.Abandoned === 1) {
      segments[segmentId].hadAbandoned = true;
    }
  });

  // Determine "Resulted in Abandoned"
  const seenSegments = new Set();

  Object.entries(segments).forEach(([segmentId, { hadMissedOrRejected, hadAbandoned, firstDate }]) => {
    if (hadMissedOrRejected && hadAbandoned && !seenSegments.has(segmentId)) {
      const dateStr = getDateStr(firstDate);
      if (!grouped[dateStr]) {
        grouped[dateStr] = { Rejected: 0, Missed: 0, ResultedInAbandoned: 0 };
      }
      grouped[dateStr].ResultedInAbandoned += 1;
      seenSegments.add(segmentId);
    }
  });

  const totals = {
    rejected: 0,
    missed: 0,
    resultedInAbandoned: 0,
  };

  Object.values(grouped).forEach(({ Rejected, Missed, ResultedInAbandoned }) => {
    totals.rejected += Rejected;
    totals.missed += Missed;
    totals.resultedInAbandoned += ResultedInAbandoned;
  });


  const labels = Object.keys(grouped).sort();
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Rejected',
        backgroundColor: '#ff9800',
        data: labels.map((date) => grouped[date].Rejected),
      },
      {
        label: 'Missed',
        backgroundColor: '#2196f3',
        data: labels.map((date) => grouped[date].Missed),
      },
      {
        label: 'Resulted in Abandoned',
        backgroundColor: '#9c27b0',
        data: labels.map((date) => grouped[date].ResultedInAbandoned),
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <div style={{ width: '50%' }}>
      <div style={{ backgroundColor: 'white', padding: '1rem 2rem', display: 'flex', justifyContent:'space-between', alignItems: 'center', borderBottom: 'solid 0.2rem #e6f2f6'}}>
        <h3>Rejected and Missed calls</h3>
        <div style={{ fontSize: '0.95rem', color: '#555' }}>
          <strong>Geweigerd:</strong> {totals.rejected} &nbsp;|&nbsp;
          <strong>Gemist:</strong> {totals.missed} &nbsp;|&nbsp;
          <strong>Resulteerden in Abandoned:</strong> {totals.resultedInAbandoned}
        </div>
      </div>
      <ChartContainer size="small">
        <Bar data={chartData} options={options} />
      </ChartContainer>
    </div>
  );
};

export default RejectedMissedChart;
